import { inject } from '@angular/core';

import { Store } from '@ngrx/store';

import { filter, map, tap } from 'rxjs/operators';

import {
  SetAvailableLanguages,
  SetCurrentLocale,
  SetDefaultLanguageCode
} from '../base-state/app/app.actions';
import { LocalStorageService } from '../storage/local-storage.service';

import { INFRASTRUCTURE_CONFIG } from '../infrastructure-config.token';
import { CheckTranslations } from '../base-state/translation/translation.actions';
import { getTranslationLoaded } from '../base-state/translation/translation.selectors';
import { I18nService } from './i18n.service';

export const TranslationsGuard = () => {
  const store = inject(Store);
  const storage = inject(LocalStorageService);
  const i18nService = inject(I18nService);
  const config = inject(INFRASTRUCTURE_CONFIG);

  return store.select(getTranslationLoaded).pipe(
    tap(loaded => {
      if (!loaded) {
        const localeKey = config.storageKeys.localeKey;
        const currentLocale = storage.getItem(localeKey);
        const appName = config.environment.app_name;
        const languageConfig = i18nService.getInfrastructureLanguageConfig();
        store.dispatch(new CheckTranslations(appName, currentLocale, false));
        store.dispatch(new SetCurrentLocale(currentLocale));
        store.dispatch(
          new SetAvailableLanguages(languageConfig.availableLanguages)
        );
        store.dispatch(
          new SetDefaultLanguageCode(languageConfig.defaultLanguageCode)
        );
      }
    }),
    filter(loaded => loaded),
    map(() => true)
  );
};
